// @ts-nocheck



import React from 'react';
import { maintenanceMatrixValidAction, maintenanceMatrixValidActionEnum } from '../../lib/enum';
import { Option, Select } from './../ant/Select';





export default ({ requiredAction = false, ...selectProps }) =>
<Select allowClear placeholder='Выберите тип' {...selectProps}>
    {Object.keys(maintenanceMatrixValidAction).
  filter((key) =>
  requiredAction ?
  true :
  key !== maintenanceMatrixValidActionEnum.required
  ).
  map((key) =>
  <Option key={key} value={key}>
          {maintenanceMatrixValidAction[key]}
        </Option>
  )}
  </Select>;
